import api from '@/plugins/axios';

// Assuming the analytics endpoint is part of the symbol-service like others
const SERVICE_PATH = '/symbol-service/api/v1/analytics/portfolio';
const NET_WORTH_PATH = '/symbol-service/api/v1/analytics/net-worth-history';
const NET_WORTH_SUMMARY_PATH = '/symbol-service/api/v1/analytics/net-worth-summary';

export default {
  getPortfolioAnalytics(portfolioId) {
    return api.get(`${SERVICE_PATH}/${portfolioId}`);
  },

  getNetWorthHistory(period = 'ALL') {
    return api.get(NET_WORTH_PATH, {
      params: { period }
    });
  },

  triggerNetWorthSnapshot() {
    return api.post(`${NET_WORTH_PATH}/trigger`);
  },

  getNetWorthSummary() {
    return api.get(NET_WORTH_SUMMARY_PATH);
  }
};
